// eslint-disable-next-line no-restricted-imports
import { Configuration, Content, DefaultApi as ErsteMarketApi } from '@eih-netbroker/api-erste-market';
import { AxiosInstance, AxiosResponse } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeaders } from '../services/useResource';
import { PositionTipp } from '../types/ersteMarket/positionTipp';
import { BaseResource } from './base.resource';

export type CarouselItem = Content;

export class ErsteMarketResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  public static name = 'ErsteMarketResource';

  private ersteMarketApi: ErsteMarketApi;

  constructor(axiosInstance: AxiosInstance, _basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, configApi.ersteMarketUrl, configApi);
    this.ersteMarketApi = new ErsteMarketApi(new Configuration(), configApi.ersteMarketUrl, axiosInstance);
  }

  public async getContent(headers: ResourceHeaders) {
    return this.ersteMarketApi.getContents(headers);
  }

  public async getPositionTipps(headers: ResourceHeaders) {
    return this.ersteMarketApi.getPositionTipps(headers) as Promise<AxiosResponse<PositionTipp[], any>>;
  }
}
